import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, tap } from 'rxjs/operators';
import { ShowNoteModalComponent } from 'src/app/components/show-note-modal/show-note-modal.component';
import { ReportMode, ReportState, ShareStatus, SortByMode } from 'src/app/model/Enums';
import { Report, ReportSummaryRequest } from 'src/app/model/report';
import { ReportProvider } from 'src/app/providers';
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver';
import { SelectCompaniesModalComponent } from './components';
import {CommonService, ReportService, ToasterService, UserService} from 'src/app/services';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('open', style({ width: '300px' })),
      state('closed', style({ width: '0px', padding: '0px' })),
      transition('open <=> closed', [animate('300ms ease-in-out')]),
    ]),
  ],
})
export class DashboardComponent implements OnInit, AfterViewInit {

  testDate: string;
  isCardView: boolean = true;
  reportList: any[] = [];
  sortByList: any[] = [];
  reportModeList: any[] = [];
  userImage1: string = 'https://i.insider.com/5899ffcf6e09a897008b5c04?width=600&format=jpeg&auto=webp';
  userImage2: string = 'https://bramdejager.files.wordpress.com/2019/05/bramdejager-600x600.png?w=300';
  userImage3: string = 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8dXNlcnxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&w=1000&q=80';

  public reportSummary = new ReportSummaryRequest();
  bsModalRef: BsModalRef;

  isLoading: boolean = false;
  isFetchingOnScroll: boolean = false;
  pageNumber: number = 1;
  totalItems: number = 0;

  reportStateEnum = ReportState;
  shareStatusEnum = ShareStatus;

  checklistDownloadUrl = environment.ASSETS_URL + 'resources/checklist.pdf';

  @ViewChild('searchInput') inputRef: ElementRef;

  showBlankPage: boolean = false;
  reportModeEnum = ReportMode;
  isSideMenuOpen: boolean = false;

  constructor(
    private reportProvider: ReportProvider,
    public reportService: ReportService,
    private toaster: ToasterService,
    private router: Router,
    public userService: UserService,
    private modalService: BsModalService,
    public common: CommonService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params.code) {
        this.common.oneTimeUserPromoCode = params.code;
      }
    });

    this.isLoading = true;
    if (!this.common.isMobileDevice && JSON.parse(localStorage.getItem('isCardView')) !== null) {
      this.isCardView = JSON.parse(localStorage.getItem('isCardView'));
    }
    this.reportService.clearReport();
    this.sortByList.push({ key: SortByMode.EVALUATION_DATE_NEWEST_FIRST, value: 'Valuation Date – Newest First', group: 'Valuation Date' });
    this.sortByList.push({ key: SortByMode.EVALUATION_DATE_OLDEST_FIRST, value: 'Valuation Date – Oldest First', group: 'Valuation Date' });
    this.sortByList.push({ key: SortByMode.COMPANY_DBA, value: 'Company DBA', group: 'Company' });
    this.sortByList.push({ key: SortByMode.REPORT_PROGRESS_FILLED_FIRST, value: 'Report Progress – Filled First', group: 'Report Progress' });
    this.sortByList.push({ key: SortByMode.REPORT_PROGRESS_EMPTY_FIRST, value: 'Report Progress – Empty First', group: 'Report Progress' });
    this.sortByList.push({ key: SortByMode.FINAL_VALUE_BIG_FIRST, value: 'Final Value - Largest First', group: 'Final Value' });
    this.sortByList.push({ key: SortByMode.FINAL_VALUE_SMALL_FIRST, value: 'Final Value - Smallest First', group: 'Final Value' });

    this.reportModeList.push({ key: ReportMode.ALL_PROJECTS, value: 'All Reports' });
    this.reportModeList.push({ key: ReportMode.MY_PROJECTS, value: 'My Reports' });
    this.reportModeList.push({ key: ReportMode.SHARED_WITH_ME, value: 'Shared With Me' });

    this.reportSummary.sort = localStorage.getItem('SORT_BY') ? localStorage.getItem('SORT_BY') : SortByMode.EVALUATION_DATE_NEWEST_FIRST; // this is temporary, need to remove it when actulal Api parameters provided
    this.reportSummary.MODE = localStorage.getItem('SHOW_MODE') ? localStorage.getItem('SHOW_MODE') : ReportMode.ALL_PROJECTS;

    this.getReportList();

    setTimeout(() => {
      this.userService.reportLockForDashboard.subscribe((v) => {
        this.lockReport(v);
      });
    }, 10);

  }

  ngAfterViewInit(): void {
    const eventStream = fromEvent(this.inputRef.nativeElement, 'keyup')
      .pipe(
        map(() => this.reportSummary.QUERY),
        debounceTime(500),
        distinctUntilChanged()
      );

    eventStream.subscribe((input) => {
      this.getReportList();
    });
  }

  /**
   * @description chnage view of dashboard
   */
  btnCard() {
    this.isCardView = true;
    localStorage.setItem('isCardView', JSON.stringify(this.isCardView));
  }

  /**
   * @description chnage view of dashboard
   */
  btnList() {
    this.isCardView = false;
    localStorage.setItem('isCardView', JSON.stringify(this.isCardView));
  }

  /**
   * @description chnage sorting dropdown
   */
  changeSortBy() {
    localStorage.setItem('SORT_BY', this.reportSummary.sort);
    this.getReportList();
  }

  /**
   * @description chnage mode of dashboard
   */
  changeShowMode() {
    localStorage.setItem('SHOW_MODE', this.reportSummary.MODE);
    this.getReportList();
  }

  /**
   * @description get report list
   */
  getReportList() {
    this.showBlankPage = false;
    if (this.reportSummary.sort === SortByMode.EVALUATION_DATE_NEWEST_FIRST) {
      this.reportSummary.SORT = 'valuationDate';
      this.reportSummary.ORDER = 'DESC';
    } else if (this.reportSummary.sort === SortByMode.EVALUATION_DATE_OLDEST_FIRST) {
      this.reportSummary.SORT = 'valuationDate';
      this.reportSummary.ORDER = 'ASC';
    } else if (this.reportSummary.sort === SortByMode.COMPANY_DBA) {
      this.reportSummary.SORT = 'dba';
      this.reportSummary.ORDER = 'ASC';
    } else if (this.reportSummary.sort === SortByMode.REPORT_PROGRESS_FILLED_FIRST) {
      this.reportSummary.SORT = 'completion';
      this.reportSummary.ORDER = 'DESC';
    } else if (this.reportSummary.sort === SortByMode.REPORT_PROGRESS_EMPTY_FIRST) {
      this.reportSummary.SORT = 'completion';
      this.reportSummary.ORDER = 'ASC';
    } else if (this.reportSummary.sort === SortByMode.FINAL_VALUE_BIG_FIRST) {
      this.reportSummary.SORT = 'value';
      this.reportSummary.ORDER = 'DESC';
    } else if (this.reportSummary.sort === SortByMode.FINAL_VALUE_SMALL_FIRST) {
      this.reportSummary.SORT = 'value';
      this.reportSummary.ORDER = 'ASC';
    }

    this.reportList = [];
    this.reportSummary.PAGE = 1;
    this.reportSummary.SIZE = 25;
    this.reportSummary.QUERY = this.reportSummary.QUERY || '';

    if (this.reportSummary.QUERY) {
      this.reportSummary.escapedQuery = encodeURIComponent(this.reportSummary.QUERY);
    } else {
      this.reportSummary.escapedQuery = '';
    }

    this.reportProvider.getReportListForDashboard(this.reportSummary).subscribe(res => {
      if (res.success) {
        this.reportList = res.result.items;
        this.totalItems = res.result.totalItems;
        this.isLoading = false;
        if (!this.reportList.length) {
          this.showBlankPage = true;
        } else {
          // this.reportList[0].isOpened = true;
        }
      } else {
        this.toaster.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });

  }

  /**
   * @description open note modal
   */
  openShowNoteModal(object) {
    this.bsModalRef = this.modalService.show(ShowNoteModalComponent, Object.assign({
      initialState: {
        reportVersionId: object.REPORT_VERSION_ID
      }
    }, { class: 'modal-lg' }));
  }

  /**
   * @description edit report
   */
  editReport(obj) {
    this.router.navigate(['/report', obj.REPORT_ID]);
  }

  /**
   * @description Create new report
   */
  createNewReport() {
    const introSkip = localStorage.getItem('VALZY_RPT_INTRO_SKIP');
    if (introSkip == 'true') {
      this.toaster.info('Please wait a moment!');
      const report = new Report();
      this.reportProvider.createReport(report).subscribe(resp => {
        if (resp.success) {
          // this.reportService.setReportId(resp.result.ID)
          this.router.navigate(['/report', resp.result.ID]);
        } else {
          this.toaster.error(resp.error.txt);
          this.router.navigateByUrl('/dashboard');
        }
      });
    } else {
      this.router.navigateByUrl('/report/introduction/required-information');
    }
  }

  /**
   * @description goto quick report
   */
  createQuickReport() {
    this.router.navigateByUrl('/express-value');
  }

  /**
   * @description host listener for scroll dashboard
   */
  @HostListener("window:scroll", ["$event"])
  getScrollHeight(): void {
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 100
      && !this.isFetchingOnScroll
      && this.reportList.length
      && this.reportList.length < this.totalItems) {
      this.isFetchingOnScroll = true;
      this.pageNumber += 1;
      this.fetchData().pipe(tap(() => this.isFetchingOnScroll = false)).subscribe();
    }
  }

  /**
   * @description provide percentage position on report box
   * @param percentage report percentage
   * @returns left position of percentage
   */
  getProgressPercentageLeftPosition(percentage: number) {
    if (percentage == 0) {
      return (percentage + 3) + '%';
    } else if (percentage > 90 && percentage < 95) {
      return (percentage - 8) + '%';
    } else if (percentage > 95) {
      return (percentage - 8) + '%';
    } else {
      return percentage + '%';
    }
  }

  /**
   * @description get report list after scroll
   */
  fetchData() {
    this.reportSummary.PAGE = this.pageNumber;
    return this.reportProvider.getReportListForDashboard(this.reportSummary).pipe(
      map(res => {
        if (res.success) {
          const reportData = res.result.items;
          reportData.forEach(ele => {
            this.reportList.push(ele);
          });
          setTimeout(() => {
            if (!this.reportList.length) {
              this.showBlankPage = true;
            }
          }, 1);
        } else {
          this.toaster.error(res.error.txt);
        }
      }, err => {
        // Error Handling
      })
    );
  }

  /**
   * @description for splice report
   */
  spliceReport(index: number) {
    this.getReportList();
  }

  /**
   * @description download checklist
   */
  downloadChecklist() {
    this.toaster.info('Please wait a moment!');
    this.reportProvider.downloadChecklistPDF().subscribe(res => {
      if (res) {
        this.saveToFileSystem(res);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description save file in system
   */
  private saveToFileSystem(response) {
    const blob = new Blob([response], { type: 'text/pdf' });
    saveAs(blob, 'Valzy Report Checklist.pdf');
  }

  /**
   * @description Get report state
   */
  getReportState(st: ReportState, completion: number): string {
    if (ReportState.CREATED == st && completion == 100) {
      return 'Awaiting Payment';
    } else if (ReportState.UNLOCKED == st && completion == 100) {
      return 'Paid';
    } else if ((ReportState.CREATED == st || ReportState.UNLOCKED == st) && completion < 100) {
      return 'Report Not Yet Complete';
    } else if (ReportState.LOCKED) {
      return 'Renew';
    }
    return '';
  }

  /**
   * @description open company selection popup
   */
  openCompanySelectionPopup() {
    let companySelectionModalRef: BsModalRef;
    companySelectionModalRef = this.modalService.show(SelectCompaniesModalComponent, Object.assign({}, { class: 'modal-lg modal-dialog-centered' }));
  }

  lockReport(wsMessage: any) {
    for (let i = 0; i < this.reportList.length; i++) {
      if (this.reportList[i].REPORT_ID == wsMessage.REPORT_ID) {
        if (wsMessage.LOCKING_USER_ID) {
          this.reportList[i].IS_LOCKED = true;
          this.reportList[i].LOCKING_USER_ID = wsMessage.LOCKING_USER_ID;
          this.reportList[i].LOCKING_USER_THUMBNAIL = wsMessage.LOCKING_USER_THUMBNAIL;
        } else {
          this.reportList[i].IS_LOCKED = false;
          this.reportList[i].LOCKING_USER_ID = null;
          this.reportList[i].LOCKING_USER_THUMBNAIL = null;
        }
      }
    }
  }

  toggleLeftMenu(): void{
    this.isSideMenuOpen = !this.isSideMenuOpen;
  }
}
